import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({providedIn: 'root'})

export class FooterServices {
    constructor(private http: HttpClient) {
    }

    checkIfUserIsLoggedIn() {
        return this.http.get('/agri/getCurrentUserInfo');
    }

    checkIfUserHaveCompany(){
        return this.http.get('/agri/getCurrentUserCompany')
    }
}
